import "./not-found.style.scss";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ROUTES_ENUM from "../../shared/routes-enum";

const NotFound = () => {
    const { t } = useTranslation();
    return (
        <div id="notfound">
            <div className="notfound">
                <motion.div
                    className="notfound-404"
                    initial={{ opacity: 0, scale: 0.25 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        duration: 0.3,
                        ease: [0, 0.71, 0.2, 1.01],
                        scale: {
                            type: "spring",
                            damping: 5,
                            stiffness: 125,
                            restDelta: 0.001,
                        },
                    }}
                >
                    <div></div>
                    <h1>404</h1>
                </motion.div>
                <h2>{t("pageNotFound")}</h2>
                <Link to={ROUTES_ENUM.BASE}>{t("homePage")}</Link>
            </div>
        </div>
    );
};

export default NotFound;
